import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router, UrlSerializer } from '@angular/router';
import { faChevronRight, faUser } from '@fortawesome/free-solid-svg-icons';
import { BusinessIntelligenceService } from 'src/app/services/business-intelligence/business-intelligence.service';
import { ManualOrderService } from 'src/app/services/manual-order/manual-order.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  faChevronRight = faChevronRight
  selected_category: any
  showCategory: any
  company_category: any;
  faUser = faUser
  summary: any;
  revenue_model: any;
  job_role: any;
  gender: any;
  is_founder: any;
  is_fulltime: any;
  company_city: any;
  company_province: any;
  survey: any;
  business_stages: any[];
  params: string;
  products: any;

  tab_menu_list = [
    {
      'id': 'product',
      'label': 'Product',

      'class': null,
    },
    {
      'id': 'category',
      'label': 'Category',

      'class': null,
    },







  ]




  productForm = new FormGroup({
    name: new FormControl(null, { validators: [Validators.required] }),
    long_description: new FormControl(null, { validators: [Validators.required] }),
    price: new FormControl(null, { validators: [Validators.required] }),
    special_price: new FormControl(null, { validators: [Validators.required] }),

    // category_name: new FormControl(null, { validators: [Validators.required] }),
    // category_id: new FormControl(null, { validators: [Validators.required] }),



  })


  categoryForm = new FormGroup({
    name: new FormControl(null, { validators: [Validators.required] }),
    parrent_id: new FormControl(null),



  })


  spinner: any;
  showModal: any;
  selectedData: any;
  sortListItems: { label: string; name: string; items: { label: string; name: string; id: string; }[]; }[];
  selected_product: any;
  tab_view: string;
  category: any;
  cat: any;
  category_product: any;
  is_search: boolean;



  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appService: BusinessIntelligenceService,
    private webService: ManualOrderService,
    private serializer: UrlSerializer,
  ) { }

  ngOnInit(): void {
    this.sortListItems = [




      // {

      //   'label': 'Category',
      //   'name': 'category_name',
      //   'items': this.cat

      // },

    ]





    this.route.queryParamMap.subscribe(queryParams => {
      console.log('hihi')
      window.scroll({
        top: 0,
        left: 0,

      });



    })


    this.route.queryParamMap.subscribe(queryParams => {
      this.tab_view = queryParams.get("tab_view")

      this.params = this.serializer.serialize(this.router.createUrlTree([''],
        { queryParams: this.route.snapshot.queryParams }))


      if (this.tab_view == 'product') {
        this.getProduct()


      }
      if (this.tab_view == 'category') {
        this.getCategory()


      }


    })
  }


  async getProduct() {


    try {

      let response = await this.webService.getProduct(this.params)

      this.products = response.data
      console.log(this.products)
    } catch (e) {
      console.log(e)
    } finally {

    }
  }



  async getCategory() {


    try {

      let response = await this.webService.getCategory(this.params)

      this.category = response.data

      this.category.sort((a, b) => a.parrent_id - b.parrent_id);

      this.cat = response.data.map(item => {



        return {
          id: item.id,
          value: item.id,
          label: item.name,
          name: item.id,

        };
      });

      if (this.sortListItems.length == 0) {
        this.sortListItems.push({
          'label': 'Category',
          'name': 'category_id',
          items: this.cat
        });
      }





      console.log(this.category)
    } catch (e) {
      console.log(e)
    } finally {

    }
  }




  async addProduct() {

    try {
      console.log(this.productForm.value)
      let response = await this.webService.addProduct(this.productForm.value)
      console.log(response)
      this.showModal = null
      this.productForm.reset()

    } catch (e) {
      console.log(e)
    } finally {

      this.ngOnInit()

    }
  }


  async selectCategoryProduct(item) {
    try {

      this.is_search = false
      let response = await this.webService.getCategoryProduct(item.id)
      console.log(response)
      console.log('selectCategoryProduct')
      this.products = response.data
      this.selected_category = item
    } catch (e) {
      console.log(e)
    } finally {



    }
  }

  async searchProduct(e) {
    if (e) {
      this.is_search = true
      let response = await this.webService.getProduct('?search=' + e)

      this.products = response.data
    } else {
      this.is_search = false
      let response = await this.webService.getCategoryProduct(this.selected_category.id)
      console.log(response)
      this.products = response.data
    }

  }

  async addCategory() {

    try {
      console.log(this.categoryForm.value)
      let response = await this.webService.addCategory(this.categoryForm.value)
      console.log(response)
      this.showCategory = null
      this.categoryForm.reset()

    } catch (e) {
      console.log(e)
    } finally {

      this.ngOnInit()

    }
  }

  updateStatus(item, e) {
    let form = {
      'status': e,
      'id': item.id
    }
    console.log(form)

    this.channelProductUpdate(form)
  }


  updateCategoryStatus(item, e) {
    let form = {
      'status': e,
      'id': item.id
    }
    console.log(form)

    this.channelCategoryUpdate(form)
  }


  // selectCategory(e) {
  //   console.log('here')
  //   console.log(e)
  //   this.productForm.get('category_name').setValue(e.name)
  //   this.productForm.get('category_id').setValue(e.id)

  // }


  selectParrentCategory(e) {
    console.log('here')
    console.log(e)
    this.categoryForm.get('parrent_id').setValue(e.id)

  }


  updateField(e, id) {

    console.log(e)
    let form = {}
    form[e.id] = e.value
    form['id'] = id
    console.log(form)
    this.channelProductUpdate(form)
  }



  updateCategoryField(e, id) {

    console.log(e)
    let form = {}
    form[e.id] = e.value
    form['id'] = id
    console.log(form)
    this.channelCategoryUpdate(form)
  }



  updateCat(e, id) {


    let form = {}
    form['category_id'] = e.name
    form['category_name'] = e.value
    form['id'] = id

    console.log(form)
    this.channelProductUpdate(form)
  }



  async onChange(event: any, item) {
    const file: File = event.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append('file', file);

      try {

        let res = await this.webService.uploadPhoto(formData, 'channel_photo')
        console.log(res)
        item.photo = res.data
        if (res.data) {
          let form = {
            'product_cover': item.photo,
            'id': item.id
          }
          this.channelProductUpdate(form)
        }

      } catch (error) {
        console.log(error)
      }
      finally {



      }

    }
  }


  async onChangeCat(event: any, item) {
    const file: File = event.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append('file', file);

      try {

        let res = await this.webService.uploadPhoto(formData, 'channel_photo')
        console.log(res)
        item.photo = res.data
        if (res.data) {
          let form = {
            'feature_image': item.photo,
            'id': item.id
          }
          this.channelCategoryUpdate(form)
        }

      } catch (error) {
        console.log(error)
      }
      finally {



      }

    }
  }


  async channelProductUpdate(form) {

    try {

      let response = await this.webService.channelProductUpdate(form, form.id)
      console.log(response)
      if (response.data) {
        this.appService.openToast('Updated')

      }

    } catch (e) {
      console.log(e)
    } finally {

      this.ngOnInit()

    }
  }


  async addCategoryProduct(item) {
    let form = {
      'channel_product_id': item.id
    }
    console.log(form)
    try {

      let response = await this.webService.addChannelCategoryProduct(this.selected_category.id, form)
      console.log(response)
      if (response.data) {
        this.appService.openToast('Produk Ditambahkan')
      }

    } catch (e) {
      console.log(e)
    } finally {


    }
  }



  async removeCategoryProduct(item) {
    let form = {
      'channel_product_id': item.id
    }
    console.log(form)
    try {

      let response = await this.webService.deleteChannelCategoryProduct(this.selected_category.id, form)
      console.log(response)
      if (response.data) {

        var index = this.products.indexOf(item);
        this.products.splice(index, 1);
        this.appService.openToast('Produk Dihapus')

      }

    } catch (e) {
      console.log(e)
    } finally {


    }
  }
  async channelCategoryUpdate(form) {

    try {

      let response = await this.webService.channelCategoryUpdate(form, form.id)
      console.log(response)
      if (response.data) {
        this.appService.openToast('Updated')

      }

    } catch (e) {
      console.log(e)
    } finally {

      this.ngOnInit()

    }
  }


  _getPercentage(total, count) {
    return Math.round((count / total) * 100)
  }




}
